import styled from 'styled-components'
import { Breakpoint, breakpointStarting, getBreakpoint } from './breakpoints'
import { px } from './utility'

export const FlexibleContainer = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (${breakpointStarting(Breakpoint.sm)}) {
    max-width: 640px;
  }
  @media (${breakpointStarting(Breakpoint.md)}) {
    max-width: 768px;
  }
  @media (${breakpointStarting(Breakpoint.lg)}) {
    max-width: 1024px;
  }
  @media (${breakpointStarting(Breakpoint.xl)}) {
    max-width: 1280px;
  }
  @media (${breakpointStarting(Breakpoint.xxl)}) {
    max-width: 1536px;
  }
`

export const FullWidthContainer = styled.div`
  width: 100%;
  max-width: ${props => px(getBreakpoint(Breakpoint.ultrahd, props.theme.breakpoints))};

  @media (${breakpointStarting(Breakpoint.ultrahd)}) {
    margin-right: auto;
  }
`
